// import React, { useCallback, useMemo } from "react";
// import ReactFlow, {
//   MiniMap,
//   Controls,
//   Background,
//   useNodesState,
//   useEdgesState,
//   addEdge,
//   Handle,
// } from "reactflow";
// import "reactflow/dist/style.css";
// import { Power, PowerOff } from "lucide-react";
// import { getSmoothStepPath, BaseEdge, EdgeLabelRenderer } from "reactflow";


// const CustomEdge = ({
//   id,
//   sourceX,
//   sourceY,
//   targetX,
//   targetY,
//   sourcePosition,
//   targetPosition,
//   data,
//   animated,
// }) => {
//   const [edgePath, labelX, labelY] = getSmoothStepPath({
//     sourceX,
//     sourceY,
//     targetX,
//     targetY,
//     sourcePosition,
//     targetPosition,
//     borderRadius: 0,
//   });

//   return (
//     <>
//       {/* Base line */}
//       <BaseEdge id={id} path={edgePath} style={{ strokeWidth: 2, stroke: "#16a34a" }} />

//       {/* Bubble animation only if animated = true */}
//       {/* {animated && (
//         <circle r="6" fill="#16a34a">
//           <animateMotion dur="2s" repeatCount="indefinite">
//             <mpath href={`#${id}-path`} />
//           </animateMotion>
//         </circle>
//       )} */}

//       {/* Invisible path reference for motion */}
//       <path id={`${id}-path`} d={edgePath} fill="none" stroke="none" />

//       {/* Label */}
//       <EdgeLabelRenderer>
//         <div
//           style={{
//             position: "absolute",
//             transform: `translate(-50%, -50%) translate(${labelX}px, ${labelY}px)`,
//             background: "rgba(255, 255, 255, 0.9)",
//             color: "#16a34a",
//             fontWeight: "bold",
//             fontSize: "18px",
//             padding: "6px 14px",
//             textAlign: "center",
//             whiteSpace: "nowrap",
//             border: "2px solid #16a34a",
//             borderRadius: "8px",
//             boxShadow: "0 0 3px rgba(0,0,0,0.3)",
//             pointerEvents: "none",
//           }}
//           className="nodrag nopan"
//         >
//           {data.label}
//         </div>
//       </EdgeLabelRenderer>
//     </>
//   );
// };



// //  Custom node
// const PowerNode = ({ data }) => {
//   const { title, type, current, power, status } = data;
//   const isOn = status === "on";
//   const barColor = isOn ? "#16a34a" : "#dc2626";

//   return (
//     <div className="rounded-2xl shadow-md bg-white border border-gray-300 w-60 text-center overflow-hidden">
//       <div
//         className="flex justify-center items-center gap-2 py-1"
//         style={{ backgroundColor: barColor }}
//       >
//         {isOn ? <Power size={18} color="#fff" /> : <PowerOff size={18} color="#fff" />}
//         <span className="text-white font-semibold text-xl">
//           {isOn ? "ON" : "OFF"}
//         </span>
//       </div>

//       <div className="p-5">
//         <div className="font-semibold text-gray-800 text-xl">{title}</div>
//         <div className="text-base text-gray-400 mb-1">{type}</div>
//         <div className="text-gray-700 font-medium text-xl">
//           Current: <span className="font-bold">{current} A</span>
//         </div>
//         <div className="text-gray-700 font-medium text-xl">
//           Power: <span className="font-bold">{power} kW</span>
//         </div>
//       </div>

//       <Handle type="source" position="bottom" style={{ background: barColor }} />
//       <Handle type="target" position="top" style={{ background: barColor }} />
//     </div>
//   );
// };

// const nodeTypes = { powerNode: PowerNode };
// const edgeTypes = { customEdge: CustomEdge };
// //  Define nodes with levels
// const nodeSpacingX = 420;
// const nodeSpacingY = 350;

// const initialNodes = [
//   {
//     id: "bus",
//     type: "default",
//     position: { x: 600, y: 0 },
//     data: { label: "Secondary Bus" },
//     style: {
//       background: "#1e293b",
//       color: "#fff",
//       fontWeight: 600,
//       padding: 10,
//       borderRadius: 8,
//       textAlign: "center",
//       width: 180,
//     },
//   },

//   //  Level 1 MCCs
//   ...["mcc-h", "mcc-i", "mcc-j", "mcc-k"].map((id, idx) => ({
//     id,
//     type: "powerNode",
//     position: { x: idx * nodeSpacingX, y: nodeSpacingY },
//     data: {
//       title: id.toUpperCase(),
//       type: "MCC",
//       current: 300 + idx * 20,
//       power: 220 + idx * 15,
//       status: idx % 2 === 0 ? "on" : "off",
//       parent: "bus",
//     },
//   })),

//   //  Level 2 Sub-panels
//   ...["pab-h", "pab-g", "tgf-1"].map((id, idx) => ({
//     id,
//     type: "powerNode",
//     position: { x: idx * nodeSpacingX * 0.8, y: nodeSpacingY * 2 },
//     data: {
//       title: id.toUpperCase(),
//       type: "Panel",
//       current: 150 + idx * 10,
//       power: 120 + idx * 20,
//       status: idx !== 2 ? "on" : "off",
//       parent: idx < 2 ? "mcc-h" : "mcc-i", // distribute under MCCs
//     },
//   })),

//   //  Level 3 End Devices
//   ...["motor-1", "pump-1", "fan-1", "motor-2"].map((id, idx) => ({
//     id,
//     type: "powerNode",
//     position: { x: idx * nodeSpacingX * 0.6, y: nodeSpacingY * 3 },
//     data: {
//       title: id.toUpperCase(),
//       type: "Equipment",
//       current: 50 + idx * 5,
//       power: 30 + idx * 10,
//       status: idx % 3 === 0 ? "off" : "on",
//       parent: idx < 2 ? "pab-h" : "pab-g", // link to sub-panels
//     },
//   })),
// ];

// //  Create edges dynamically from parent property
// const makeEdges = (nodes) =>
//   nodes
//     .filter((n) => n.id !== "bus")
//     .map((n, idx) => ({
//       id: `e-${n.id}`,
//       source: n.data.parent || "bus",
//       target: n.id,
//       type: "step",
//       animated: n.data?.status === "on",
//       style: { strokeWidth: 2 },
//       // data: { label: `${n.data?.current || 0}A / ${n.data?.power || 0}kW` },
//       index: idx,
//     }));

// export default function PowerFlowSLD() {
//   const [nodes] = useNodesState(initialNodes);
//   const initialEdges = useMemo(() => makeEdges(initialNodes), []);
//   const [edges] = useEdgesState(initialEdges);

//   return (
//     <div
//       style={{
//         width: "100%",
//         height: "90vh",
//         position: "relative",
//         overflow: "visible",
//       }}
//     >
//       <ReactFlow
//         nodes={nodes}
//         edges={edges}
//         nodeTypes={nodeTypes}
   
//         nodesDraggable={false}        
//         nodesConnectable={false}      
//         elementsSelectable={false}    
//         panOnDrag={false}             
//         zoomOnScroll={true}            
//         zoomOnPinch={true}            
//         panOnScroll={false}           
//         // minZoom={0.5}
//         // maxZoom={1.5}
//         defaultViewport={{ x: 10, y: 0, zoom: 0.72 }}
//         fitView
//       >
//         <MiniMap
//           nodeColor={(n) => (n.data?.status === "off" ? "#dc2626" : "#16a34a")}
//         />
//         <Controls showInteractive={false} /> {/* ✅ keep only zoom buttons */}
//         <Background color="#e2e8f0" gap={16} />
//       </ReactFlow>
//     </div>
//   );
// }


// // export default function PowerFlowSLD() {
// //   const [nodes, , onNodesChange] = useNodesState(initialNodes);
// //   const initialEdges = useMemo(() => makeEdges(initialNodes), []);
// //   const [edges, setEdges, onEdgesChange] = useEdgesState(initialEdges);

// //   const onConnect = useCallback(
// //     (params) =>
// //       setEdges((eds) => addEdge({ ...params, type: "customEdge" }, eds)),
// //     [setEdges]
// //   );

// //   return (
// // <div style={{ width: "100%", height: "90vh", position: "relative", overflow: "visible" }}>

// //       <ReactFlow
// //         nodes={nodes}
// //         edges={edges}
// //         nodeTypes={nodeTypes}
// //         edgeTypes={edgeTypes}
// //         onNodesChange={onNodesChange}
// //         onEdgesChange={onEdgesChange}
// //         onConnect={onConnect}
// //         // fitView
// //         defaultViewport={{ x: 10, y: 0, zoom: 0.72 }}
// //       >
// //         <MiniMap
// //           nodeColor={(n) => (n.data?.status === "off" ? "#dc2626" : "#16a34a")}
// //         />
// //         <Controls />
// //         <Background color="#e2e8f0" gap={16} />
// //       </ReactFlow>
// //     </div>
// //   );
// // }
import React from "react";
import ReactFlow, { MiniMap, Controls, Background, Handle } from "reactflow";
import "reactflow/dist/style.css";
import { Power, PowerOff } from "lucide-react";
import { useSelector } from "react-redux";

// const PowerNode = ({ data }) => {
//   const { title, type, parameters, status } = data;
//   const color =
//     status === "on" ? "#16a34a" : status === "off" ? "#dc2626" : "#f97316";

//   return (
//     <div
//       className="rounded-2xl shadow-md border w-60 text-center overflow-hidden select-none"
//       style={{ background: "#fff", borderColor: color }}
//     >
//       <div
//         className="flex justify-center items-center gap-2 py-1"
//         style={{ backgroundColor: color }}
//       >
//         {status === "on" ? (
//           <Power size={18} color="#fff" />
//         ) : status === "off" ? (
//           <PowerOff size={18} color="#fff" />
//         ) : (
//           <Power size={18} color="#fff" />
//         )}
//         <span className="text-white font-semibold text-base">
//           {status ? status.toUpperCase() : "NO STATUS"}
//         </span>
//       </div>

//       <div className="p-4">
//         <div className="font-semibold text-gray-800 text-lg">{title}</div>
//         <div className="text-sm text-gray-500 mb-2">{type}</div>
//         <div className="space-y-1 text-gray-700">
//           {parameters.length === 0 ? (
//             <div className="italic text-gray-400">No parameters</div>
//           ) : (
//             parameters.map((param) => (
//               <div key={param} className="font-medium text-sm">
//                 {param}: <span className="font-bold">—</span>
//               </div>
//             ))
//           )}
//         </div>
//       </div>

//       <Handle type="source" position="bottom" style={{ background: color }} />
//       <Handle type="target" position="top" style={{ background: color }} />
//     </div>
//   );
// };

const PowerNode = ({ data, id }) => {
  const {
    title,
    equipmentType,
    parameters = [],
    status,
    operation,
    power = 0,
    current = 0,
    voltage = 0,
  } = data;
  // const { makeRequest } = useStoreUpdaterWithAPI();

  // Log data for debugging
  console.log("Node Data:", data);

  // Status color
  const color =
    status === "ON" ? "#16a34a" : status === "OFF" ? "#dc2626" : "#f97316";

  // Icon status handling
  const statusIcon =
    status === "ON" ? <Power size={18} /> : status === "OFF" ? <PowerOff size={18} /> : <></>;

  // Map parameter names to their corresponding values
  const paramValues = {
    Power: power,
    Current: current,
    Voltage: voltage,
  };

  const handleUpdate = () => {
    console.log("Update Node Data:", { id, ...data });

  };

  const handleDelete = () => {
    console.log("Delete Node Data:", { id, ...data });
    console.log("Delete Node Data:", data );
      makeRequest({
      type: APIConstants.DELETE,
      url: `${APIConstants.DELETE_SLD_DATA}?ParentNodeID=${data.parent}`,
    }).then((res) => {
      console.log(res.message);
      
    });
  };
  console.log(status)

  return (
    <div
      className="rounded-xl  border w-64 text-center overflow-hidden select-none shadow-xl"
      style={{
        // background: "#fff",
        // borderColor: color,
      }}
    >
      {/* --- Header --- */}
      <div className="flex justify-between items-center py-1 px-3" style={{ backgroundColor: color }}>
        <div className="flex items-center gap-2 text-white">
          {statusIcon}
          <span className="font-semibold text-sm">
            {status ? status.toUpperCase() : ""} 
          </span>
        </div>
      </div>

      {/* --- Node Info --- */}
      <div className="p-3">
        <div className="font-semibold text-gray-800 text-base">{title}</div>
        <div className="text-sm text-gray-500 mb-2">{equipmentType}</div>

        {/* Parameters with values */}
        <div className="space-y-1 text-gray-700">
          {parameters.length === 0 ? (
            <div className="italic text-gray-400 text-sm">
              {/* No parameters selected */}
            </div>
          ) : (
            parameters.map((param) => (
              <div key={param} className="font-medium text-sm">
                {param}:{" "}
                <span className="font-bold">
                  {paramValues[param] !== undefined ? paramValues[param] : "—"}
                </span>
              </div>
            ))
          )}
        </div>
      </div>

      {/* ReactFlow Handles */}
      <Handle type="source" position="bottom" style={{ background: color }} />
      <Handle type="target" position="top" style={{ background: color }} />
    </div>
  );
};
const nodeTypes = { powerNode: PowerNode };

export default function PowerFlowSLDViewer() {

  const nodes = useSelector((state) => state.sld.nodes);
  const edges = useSelector((state) => state.sld.edges);
  console.log(nodes)
  console.log(edges)

  return (
    <div className="">
      
    <div style={{ width: "100%", height: "90vh", background: "#f8fafc" }}>
      {nodes.length === 0 ? (
        <div className="text-center mt-10 text-gray-500">
          <p>No SLD data found.</p>
          <p>Please create your flow first.</p>
        </div>
      ) : (
        <ReactFlow
          nodes={nodes}
          edges={edges}
          nodeTypes={nodeTypes}
          nodesDraggable={false}
          zoomOnScroll={true}
          zoomOnPinch={true}
          panOnDrag={true}
          fitView
        >
          <MiniMap
            nodeColor={(n) =>
              n.data?.status === "on"
                ? "#16a34a"
                : n.data?.status === "off"
                ? "#dc2626"
                : "#f97316"
            }
          />
          <Controls showInteractive={false} />
          <Background color="#e2e8f0" gap={16} />
        </ReactFlow>
      )}
    </div>
    </div>
  );
}
